import CSCPTable from "../cscp-table"
export default class EventListReport extends CSCPTable {
    constructor() {
        super();
    }

    initSettings() {
        let that = this;

        that.instance = "cscpjs.default.eventListReportjs";
        that.method = "/Reports/EventsPaging";
        that.tableId = "eventsTable";
        that.searchBtnEleId = "eventsTableSearch";

        that.columns = [
            { data: "EventTitle", class: "column-1" },
            { data: "EventStartDate", class: "column-1" },
            {
                customContent: (row) => {
                    return `<a
                                onclick="cscpjs.default.ajaxjs.loadPartialActionControllerQuerystringElementId('EventSignInSheet', 'Reports', '?eventId=${row.ContentID}&user=${that.additionalAttr.user}&hash=${that.additionalAttr.hash}', 'eventReportParent')">
                                ${that.additionalAttr.SignInSheetLabel}
                            </a>`
                }, class: "column-3"
            },
            {
                customContent: (row) => {
                    return `<a 
                                onclick="cscpjs.default.ajaxjs.loadPartialActionControllerQuerystringElementId('EventBadgeList', 'Reports', '?eventId=${row.ContentID}&user=${that.additionalAttr.user}&hash=${that.additionalAttr.hash}', 'eventReportParent')">
                                 ${that.additionalAttr.BadgesLabel}
                            </a>`
                }, class: "column-3"
            },
            {
                customContent: (row) => {
                    return `<a
                                onclick="cscpjs.default.ajaxjs.loadPartialActionControllerQuerystringElementId('EventMailingList', 'Reports', '?eventId=${row.ContentID}&user=${that.additionalAttr.user}&hash=${that.additionalAttr.hash}', 'eventReportParent')">
                                ${that.additionalAttr.MailingListLabel}
                            </a>`
                }, class: "column-3"
            }
        ]
        that.filterContainerEleId = "reportFilterForm";
    }

    customLocalFilter(item) {
        const eventStartDate = document.getElementById("eventStartDate").value;

        if (Date.parse(item.EventStartDate) < Date.parse(eventStartDate)) {
            return false;
        }

        return true;

    }
}





// WEBPACK FOOTER //
// ./Scripts/es6/Controllers/eventListReport.js